/**
 * modalBackdrop.js — закрытие модала кликом по затемнению, без ложных срабатываний.
 *
 * ПРОБЛЕМА. Наивная проверка
 *
 *   <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
 *
 * закрывает модал, когда пользователь ВЫДЕЛЯЕТ ТЕКСТ внутри и отпускает кнопку
 * за его краем: событие click браузер шлёт общему предку mousedown- и
 * mouseup-таргетов, то есть самому затемнению, и условие срабатывает. Набранная
 * форма исчезает на ровном месте. На тач-устройствах то же самое, когда палец
 * начал движение внутри и ушёл за границу.
 *
 * РЕШЕНИЕ. Смотрим, где НАЧАЛОСЬ нажатие: закрываем, только если и pointerdown,
 * и click пришлись на само затемнение. Правило записано в CLAUDE.md
 * («модалки: закрытие по pointerdown-таргету»).
 *
 * ПОЧЕМУ НЕ ХУК. Затемнения встречаются и после ранних return, и внутри
 * условных веток JSX — хук туда не поставить, не нарушив правила порядка
 * хуков. Поэтому признак храним на самом DOM-узле затемнения: он переживает
 * ре-рендер между pointerdown и click, а функцию можно звать прямо в разметке.
 *
 * Использование:
 *
 *   <div className="modal-overlay" {...backdropClose(onClose)}>…</div>
 *
 * @param {function|null|undefined} onClose — вызвать при клике по затемнению.
 *        Пустое значение = закрытие по фону выключено (например, идёт отправка).
 */
export function backdropClose(onClose) {
  return {
    onPointerDown: (e) => {
      // dataset, а не ref: узел один и тот же, а компонент между двумя
      // событиями может успеть перерисоваться.
      e.currentTarget.dataset.backdropDown = String(e.target === e.currentTarget);
    },
    onClick: (e) => {
      if (!onClose) return;
      if (e.target === e.currentTarget && e.currentTarget.dataset.backdropDown === 'true') onClose();
    },
  };
}

export default backdropClose;
